import { gql } from '@apollo/client';

export interface GetTeachersVariables {
    where: {
        id: string;
    };
}

export interface GetTeachersResponse {
    school: {
        teachers: {
            user: {
                email: string;
            };
            name: string;
        }[];
    };
}

export const GET_TEACHERS = gql`
    query Teachers($where: SchoolWhereUniqueInput!) {
        school(where: $where) {
            teachers {
                id
                name
                user {
                    email
                }
            }
        }
    }
`;
